package com.essntl.features.itinerary.ui.edit_itinerary_service

import com.essntl.features.address.domain.model.GooglePlaceModel
import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.supplier.domain.model.SupplierModel
import com.essntl.features.task.domain.model.TaskModel
import com.mohamedrejeb.calf.core.PlatformContext

sealed interface EditItineraryServiceEvent {

    /**
     * Itinerary Service Events
     */

    data class GetItineraryService(
        val itineraryServiceId: String,
        val itineraryId: String,
    ) : EditItineraryServiceEvent

    data class UpdateItineraryService(val context: PlatformContext) : EditItineraryServiceEvent

    data class GetSuppliers(val service: ServiceModel) : EditItineraryServiceEvent

    data object ClearItineraryService : EditItineraryServiceEvent
    data object ClearSupplier : EditItineraryServiceEvent
    data class UpdateProposal(val proposal: ProposalModel) : EditItineraryServiceEvent

    data class UpdateItineraryServiceFields(val itineraryService: ItineraryServiceModel) : EditItineraryServiceEvent

    data class UpdateItineraryStatus(
        val itineraryService: ItineraryServiceModel,
        val status: ItineraryServiceModel.Status,
    ) : EditItineraryServiceEvent

    data class UpdateItineraryServiceSupplier(
        val itineraryService: ItineraryServiceModel,
        val supplier: SupplierModel,
    ) : EditItineraryServiceEvent

    /**
     * Task Events
     */

    data class DeleteTask(
        val task: TaskModel,
    ) : EditItineraryServiceEvent

    data class EditTaskStatus(
        val taskId: String,
        val status: TaskModel.Status,
    ) : EditItineraryServiceEvent

    /**
     * Client Events
     */
    data class GetClientById(val clientId: String) : EditItineraryServiceEvent

    /**
     * Request Events
     */
    data class GetRequestById(val requestId: String) : EditItineraryServiceEvent

    /**
     * Category Events
     */

    data object GetAllCategories : EditItineraryServiceEvent

    /**
     * Attachments Events
     */
    data class AddAttachments(val files: List<FileModel>) : EditItineraryServiceEvent
    data class DeleteAttachment(val index: Int) : EditItineraryServiceEvent


    /**
     * Address Events
     */
    data class GetPlaces(val searchText: String) : EditItineraryServiceEvent
    data class SelectPlace(val place: GooglePlaceModel) : EditItineraryServiceEvent
    data object SetPlace : EditItineraryServiceEvent
    data object ClearPlace : EditItineraryServiceEvent
}